import EnvFile from "./assets/env-prod.json";

declare global {
  interface Window {
    MLBBest: {
      envVariables: Record<string, string | boolean>;
    };
  }
}

window.MLBBest = {
  envVariables: EnvFile as Record<string, string | boolean>,
};
